import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { MenuProvider } from "./contexts/DrawerContext";
import ThemeCustomization from "./theme";
import { PropertyProvider } from "./contexts/PropertyContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
function Root() {
  return (
    <React.StrictMode>
      <ThemeCustomization>
        <PropertyProvider>
          <MenuProvider>
            <App />
          </MenuProvider>
        </PropertyProvider>
      </ThemeCustomization>
    </React.StrictMode>
  );
}

root.render(<Root />);
